
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobilesearch",
      function () {
        return require("private-next-pages/mobilesearch.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobilesearch"])
      });
    }
  